<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="dev-list" :class="{ 'is-collapse': collapse, 'fold': tagManagerFold }">
    <div class="tag-area" :class="!collapse&&'no-collapse'">
      <tag-manager ref="tagManager" v-model="query.tagid" type="dev" @toggle="handleTagManagerToggle"
        @change="fetchData(1)" @update="fetchData()" @delete="fetchData()">
      <div slot="tag-name">模型管理</div>
    </tag-manager>
    </div>
    <div class="table-area">
      <div class="filter-container">
        <div class="filter-box">
          <div class="filter-item sm">
            <f-search-input v-model="query.keyword" width="160" placeholder="模型名称" prefix-icon="el-icon-search"
              clearable @change="fetchData(1)" />
          </div>
        </div>
        <div class="toolbox">
          <el-button icon="el-icon-plus" type="primary" @click="createDev">新建模型</el-button>
          <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
        </div>
      </div>
      <el-card v-loading="loading" shadow="never" class="card">
        <el-table ref="listTable" :data="list" :row-style="{ 'height': '61px' }" tooltip-effect="dark">
          <el-table-column width="60" type="index" label="#" />
          <el-table-column label="模型名称" min-width="240">
            <div slot-scope="scope">
              <div class="flex">
                <f-dev-name class="font-md" :dev="scope.row" />
                <tag-panel :ref="'tagPanel' + scope.row.devid" class="ml-sm" type="dev" :unique-key="scope.row.devid"
                  :title="scope.row.dev_name" :tags="scope.row.tags" @update="handleTagPanelUpdate" />
              </div>
              <div v-if="scope.row.remark" class="text-muted font-sm" style="line-height: 17px;">{{ scope.row.remark }}
              </div>
            </div>
          </el-table-column>

          <el-table-column label="设备数量" width="140" align="center">
            <template slot-scope="scope">
              <span class="font-lg">{{ scope.row.dev_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="链接协议" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.protocal }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="更新时间" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.cmd_updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              <el-tooltip v-if="scope.row.cmd_updatetime > scope.row.last_sync_time" placement="top">
                <div slot="content">
                  <span v-if="scope.row.last_sync_time">上次同步时间：{{ scope.row.last_sync_time | parseTime('{y}/{m}/{d} {h}: {i}') }}</span>
                  <span v-else>尚未同步</span>
                </div>
                <span class="ml-sm font-lg middle text-danger"><i class="iconfont icon-circle-warning-b" /></span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <f-dev-name type="button" :dev="scope.row" />
              <el-dropdown trigger="click" placement="bottom-start" class="ml-sm" >
                <el-button type="text">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editDevRemark(scope.row)">备注</el-dropdown-item>
                  <el-dropdown-item @click.native="cloneDev(scope.row)">克隆</el-dropdown-item>
                  <el-dropdown-item @click.native="deleteDev(scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <template slot="append">
            <div class="foot-menu" :class="[!collapse && 'active', !tagManagerFold && 'fold']">
              <f-table-footer>
                <template slot="right">
                  <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize"
                    @change="fetchData" />
                </template>
              </f-table-footer>
            </div>
          </template>

          <div slot="empty" class="flex-center column pb-md">
            <div class="flex-center mt-hg">
              <img src="../../assets/no-data.png" alt="" class="no-data">
            </div>
            <el-button type="warning" class="mt-xs" plain @click="toDoc">了解如何创建模型</el-button>
          </div>
        </el-table>
      </el-card>
    </div>


    <dev-creater v-if="devCreating" :show.sync="devCreating" @onSubmit="fetchData(1)" />
    <dev-clone v-if="cloning" :show.sync="cloning" :devid="activeDev.devid" :dev-name="activeDev.dev_name"
      @onSubmit="fetchData(1)" />
  </div>
</template>

<script>
import { getDevListApi, deleteDevApi, editDevProfileApi } from "@/api/dev/devApi";
export default {
  name: "DevList",

  components: {
    TagManager: () => import("@/views/fam/components/TagManager"),
    TagPanel: () => import("@/views/fam/components/TagPanel"),
    DevCreater: () => import("@/views/dev/components/DevCreater"),
    DevClone: () => import("@/views/dev/components/DevClone")
  },

  data() {
    return {
      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 5, title: "最近更新" },
        { value: 7, title: "最多设备" },
        { value: 2, title: "按名称 A-Z" },
        { value: 3, title: "按名称 Z-A" }
      ],
      loading: false,
      query: {
        tagid: 0,
        keyword: "",
        sort: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      list: [],
      total: 0,

      version_limit: {
        aiot_version: 0,
        dev_total: 0,
        dev_upper_limit: 0
      },

      tagManagerFold: Number(localStorage.getItem(`__TAG_MANAGER_FOLD_DEV__`)),

      devCreating: false,

      cloning: false,
      clonedDevid: undefined,
      activeDev: {
        devid: undefined
      }
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version
    },
  },

  created() {
    this.query = this.$utils.initListQuery(this.query, ["/dev/detail"]);
    this.fetchData();
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  methods: {
    devchange(dev) {
      // console.log("devchange", dev);
    },

    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      getDevListApi(this.query).then(res => {
        this.loading = false;
        if (res.errno === 0) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.query.sort = res.data.sort
          this.version_limit = Object.assign({}, res.data.version_limit)
        }
      });
    },


    createDev() {
      if (this.version_limit.aiot_version == 0  && this.version_limit.dev_total >= this.version_limit.dev_upper_limit) {
        this.$message.error('免费版AIOT用户支持新建最多' + this.version_limit.dev_upper_limit + '个模型，如需建更多模型请升级企业版')
        return
      }
      this.devCreating = true;
    },

    cloneDev(dev) {
      this.activeDev = Object.assign({}, dev);
      this.cloning = true;
    },

    deleteDev(dev) {
      const msg = `即将删除模型 <span class="text-danger">${
        dev.dev_name
      }</span>，删除后不可恢复，是否继续？`;
      this.$confirm(msg, "操作确认", {
        type: "error",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          deleteDevApi([dev.devid]).then(res => {
            if (!res.errno) {
              this.$message.success(res.message);
              this.fetchData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    editDevRemark(row) {
      this.$prompt(`请输入备注信息`, row.dev_name, {
        inputValue: row.remark,
        closeOnClickModal: false
      })
        .then(({ value }) => {
          editDevProfileApi({ devid: row.devid, remark: value }).then((res) => {
            if (!res.errno) {
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    handleTagManagerToggle(val) {
      this.tagManagerFold = val;
    },
    handleTagPanelUpdate() {
      this.fetchData();
      this.$refs["tagManager"].fetchData();
    },

    toDevDetail(devid) {
      this.$router.push("/dev/detail?devid=" + devid);
    },

    toDoc() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/22");
    }
  }
};
</script>

<style lang="scss" scoped>
.dev-list {
  .tag-area {
    position: fixed;
    top: 60px;
    left: 160px;
    width: 240px;
    height: calc(100% - 60px);
    background-color: #fff;
    &.no-collapse {
      border-bottom-left-radius: 20px;
    }
  }

  .table-area {
    padding-left: 240px;
    padding-bottom: 60px;
    /deep/ .card {
      margin-bottom: 20px;
      border: none;
    }
  }

  &.fold {
    .tag-area {
      width: 60px;
    }

    .table-area {
      padding-left: 60px;
    }
  }

  &.is-collapse {
    .tag-area {
      left: 60px;
    }
  }
}
/deep/ .sort {
  width: 80px;
}
.no-data {
  width: 200px;
  height: 200px;
}
.foot-menu {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 120px;
  width: calc(100% - 120px);
  z-index: 3;
  padding-left: 20px;
  padding: 4px 30px 5px 20px;

  &.active {
    left: 220px;
    width: calc(100% - 220px);
  }

  &.fold {
    left: 300px;
    width: calc(100% - 300px);
  }

  &.active.fold {
    left: 400px;
    width: calc(100% - 400px);
  }

  .f-table-footer {
    margin: 0;
    height: 50px;
  }
}
</style>
